// Sojern Pixel Configuration for different hotels
// Each hotel has its own advertiser ID and set of pixel IDs for search, cart, and conversion tracking

// Hotel-specific configuration using hotel IDs as keys
export const HOTEL_PIXEL_MAPPING = {
  // Hotel Suba International
  "7876": {
    hotelName: "Hotel Suba International",
    advertiserId: "74017",
    search: 382465,
    cart: 382466,
    conversion: 382464,
    city: "Mumbai",
    state: "Maharashtra",
    country: "IN",
    nearestAirport: "BOM"
  },
  // Hotel Suba Palace
  "7877": {
    hotelName: "Hotel Suba Palace",
    advertiserId: "74020",
    search: 382481,
    cart: 382484,
    conversion: 382482,
    city: "Mumbai",
    state: "Maharashtra",
    country: "IN",
    nearestAirport: "BOM"
  },
  // Hotel Suba Galaxy
  "7875": {
    hotelName: "Hotel Suba Galaxy",
    advertiserId: "74019",
    search: 382476,
    cart: 382479,
    conversion: 382478,
    city: "Mumbai",
    state: "Maharashtra",
    country: "IN",
    nearestAirport: "BOM"
  }
  // Add more hotels as needed following this format:
  // "hotelId": {
  //   hotelName: "Hotel Name",
  //   advertiserId: "advertiser_id",
  //   search: "search_pixel_id",
  //   cart: "cart_pixel_id",
  //   conversion: "conversion_pixel_id",
  //   city: "cityName",
  //   state: "stateName",
  //   country: "countryCode",
  //   nearestAirport: "airportCode"
  // }
};

// Function to get pixel configuration for a hotel by ID
export const getHotelPixelConfig = (hotelId) => {
  if (!hotelId) {
    console.warn('No hotel ID provided for Sojern pixel tracking');
    return null;
  }
  
  // Convert to string if number is passed
  const hotelIdStr = String(hotelId);
  
  // Direct lookup by hotel ID
  if (HOTEL_PIXEL_MAPPING[hotelIdStr]) {
    return HOTEL_PIXEL_MAPPING[hotelIdStr];
  }
  
  // No match found
  console.warn(`No Sojern pixel configuration found for hotel ID: ${hotelId}`);
  return null;
};

// Function to get pixel configuration by hotel name (fallback)
export const getHotelPixelConfigByName = (hotelName) => {
  if (!hotelName) {
    return null;
  }
  
  const normalizedName = hotelName.toLowerCase().trim();
  
  // Search through all configurations to find matching hotel name
  for (const [hotelId, config] of Object.entries(HOTEL_PIXEL_MAPPING)) {
    if (config.hotelName && config.hotelName.toLowerCase().trim() === normalizedName) {
      return config;
    }
  }
  
  // Try partial match
  for (const [hotelId, config] of Object.entries(HOTEL_PIXEL_MAPPING)) {
    if (config.hotelName) {
      const configName = config.hotelName.toLowerCase();
      if (normalizedName.includes(configName) || configName.includes(normalizedName)) {
        console.info(`Using partial match for hotel: ${hotelName} -> ${config.hotelName}`);
        return config;
      }
    }
  }
  
  return null;
};

// Helper function to check if a hotel has Sojern pixels configured
export const hasSojernPixels = (hotelId) => {
  if (!hotelId) return false;
  const hotelIdStr = String(hotelId);
  return HOTEL_PIXEL_MAPPING.hasOwnProperty(hotelIdStr);
};

// Default configuration for fallback (should not be used in production)
export const DEFAULT_PIXEL_CONFIG = {
  hotelName: "",
  advertiserId: null,
  search: null,
  cart: null,
  conversion: null,
  city: "",
  state: "",
  country: "IN",
  nearestAirport: ""
};